export default __webpack_public_path__ + "static/media/dropdown_icons.c0e1ebfc.svg";